import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UserDataService {
    _userData: any;
    dataLoading = signal<boolean>(false);

    set userData(data: any) {
        this._userData = data;
    }
    get userData() {
        return this._userData;
    }

    isBrazilBankRegEnabled({ br_bank_registration_journey_enabled, br_new_bank_registration_journey_enabled }: any): boolean {
        return br_bank_registration_journey_enabled == 'Y' || br_new_bank_registration_journey_enabled == 'Y';
    }
}
